import React from "react";

const Dashboard = () => (
  <div>Admin Dashboard Page...</div>
);

export default Dashboard;
